import { Directive, HostListener, Input } from '@angular/core';
import { TagManagerService } from '@services/tag-manager.service';
import { GoogleTagManagerModel } from '../models/google-tag-manager.model';

@Directive({ selector: '[tag]' })
export class TagManagerDirective {

  @Input() tag!: GoogleTagManagerModel;

  constructor(private readonly tagManagerService: TagManagerService) {
  }

  @HostListener('click') onClick() {
    this.tagManagerService.pushTag(this.tag);
  }
}
